// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v5/get_phone_mfa_options.proto

/* oxlint-disable */

/**
 * Request message for GetPhoneMfaOptions (GET /v5/user/phone_number/mfa_options).
 * No request body — authenticated user is inferred from session.
 */
export interface ApiGetPhoneMfaOptionsRequest {
}

/**
 * Response message for GetPhoneMfaOptions.
 * Returns available MFA methods for the phone change flow.
 */
export interface ApiGetPhoneMfaOptionsResponse {
  /** Available MFA methods (e.g. "by_sms", "by_email"). */
  readonly mfaOptions: readonly string[];
}

export const ApiGetPhoneMfaOptionsRequest: MessageFns<ApiGetPhoneMfaOptionsRequest> = {
  fromJSON(_: any): ApiGetPhoneMfaOptionsRequest {
    return {};
  },

  toJSON(_: ApiGetPhoneMfaOptionsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetPhoneMfaOptionsResponse: MessageFns<ApiGetPhoneMfaOptionsResponse> = {
  fromJSON(object: any): ApiGetPhoneMfaOptionsResponse {
    return {
      mfaOptions: globalThis.Array.isArray(object?.mfa_options)
        ? object.mfa_options.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ApiGetPhoneMfaOptionsResponse): unknown {
    const obj: any = {};
    if (message.mfaOptions?.length) {
      obj.mfa_options = message.mfaOptions;
    }
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
